import { RefObject } from 'react'
import { View } from 'react-native'

export const measureSubcategoriesContainerWidth = (
    ref: RefObject<View | null>
): Promise<number> => {
    return new Promise((resolve, reject) => {
        if (!ref.current) return reject(new Error('ref.current is not available'))

        ref.current.measure((_, _1, width) => resolve(width))
    })
}
